import React, { useState} from "react";
import {createNewWishList} from "../../../DAL/data-service";
import {IWishList} from "../../../interfaces";
import {sendGAEvent} from "../../../../../domain/marketing/gtm-provider";
import NewWishlistCommon from "../new-wishlist-common";

/**
 * Create new wish list
 * In use in AddToWishlist component
 */
const NewWishlist: React.FC<{hideAddToWishlistPopup:()=>void}>  = ({hideAddToWishlistPopup}) => {
    const [newWishlistName, setNewWishlistName] = useState("");
    const [newWishlistPurl, setNewWishlistPurl] = useState("");
    const [showSuccess, setShowSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");


    const CreateWishList = async (newWishlistName:string) => {

        const response = await createNewWishList(newWishlistName);
        if(response.statusCode !== 200) {
            setErrorMessage("An error has occurred.");
            return;
        }
        sendGAEvent("Wish List","Create New Wish List");
        let newWishList  = response.data.relatedData as IWishList;
        setNewWishlistPurl(newWishList.purl);
        setNewWishlistName(newWishlistName);
        setShowSuccess(true);
    }
    return (
        <>
            {showSuccess ?
                <div className="p-4 w-80">
                    <div className="font-bold pb-2 text-center">
                        The list <a href={'https://'+window.location.host+'/account/wishlist/'+newWishlistPurl} className="text-blue-200 cursor-pointer" >
                        {newWishlistName}
                    </a> has been created</div>
                    <div className="flex items-center justify-center w-full pt-6">
                        <button className="w-btn inline-block bg-blue-200 text-white font-normal w-auto px-9" onClick={hideAddToWishlistPopup}>
                            <span>Close</span>
                        </button>
                    </div>

                </div>
                :
                <NewWishlistCommon
                    hidePopup={hideAddToWishlistPopup}
                    submit={CreateWishList}
                    errorMessage={errorMessage}
                />

            }
        </>
    )
};

export default NewWishlist;